import React, { useCallback } from 'react';
import { Autocomplete, TextField, autocompleteClasses } from '@mui/material';
import { COUNTRIES, Country } from 'constants/countries';

interface CountrySelectProps {
  value: string;
  onChange: (value: string) => void;
  error?: string;
  placeholder?: string;
}

const CountrySelect: React.FC<CountrySelectProps> = ({
  value,
  onChange,
  error,
  placeholder = 'Country',
}) => {
  const selectedCountry = COUNTRIES.find((c) => c.code === value) || null;

  const handleChange = useCallback(
    (_event: React.SyntheticEvent, newValue: Country | null) => {
      onChange(newValue?.code || '');
    },
    [onChange]
  );

  return (
    <Autocomplete
      value={selectedCountry}
      onChange={handleChange}
      options={COUNTRIES}
      getOptionLabel={(option) => option.name}
      isOptionEqualToValue={(option, val) => option.code === val.code}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={placeholder}
          error={!!error}
          helperText={error}
          sx={{
            '& .MuiOutlinedInput-root': {
              height: '50px',
              borderRadius: '8px',
              backgroundColor: '#181818',
              color: 'white',
              fontFamily: 'Plus Jakarta Sans',
              fontSize: '11px',
              border: '1px solid #323232',
              '& fieldset': {
                border: 'none',
              },
              '&:hover fieldset': {
                border: 'none',
              },
              '&.Mui-focused fieldset': {
                border: 'none',
              },
            },
            '& .MuiOutlinedInput-input': {
              padding: '0 14px !important',
              color: 'white',
              fontFamily: 'Plus Jakarta Sans',
              fontSize: '11px',
              '&::placeholder': {
                color: 'gray',
                fontStyle: 'italic',
                opacity: 1,
              },
            },
            '& .MuiFormHelperText-root': {
              color: '#ff4444',
              marginLeft: 0,
              marginTop: '4px',
            },
          }}
        />
      )}
      sx={{
        width: '100%',
        '& .MuiSvgIcon-root': {
          color: 'white',
        },
      }}
      slotProps={{
        paper: {
          sx: {
            bgcolor: '#181818',
            color: 'white',
            fontFamily: 'Plus Jakarta Sans',
            fontSize: '11px',
            borderRadius: '8px',
            border: '1px solid #323232',
            marginTop: '4px',
            maxHeight: '300px',
            [`& .${autocompleteClasses.listbox}`]: {
              padding: 0,
              '& li': {
                padding: '8px 14px',
                fontFamily: 'Plus Jakarta Sans',
                fontSize: '11px',
                cursor: 'pointer',
                '&:hover': {
                  backgroundColor: '#2a2a2a',
                },
                '&[aria-selected="true"]': {
                  backgroundColor: '#323232',
                },
              },
            },
          },
        },
      }}
    />
  );
};

export default CountrySelect;
